if (!customElements.get('product-addons-cart')) {
    customElements.define(
        'product-addons-cart',
        class ProductAddonsCart extends HTMLElement {
            constructor() {
                super();
                
                this.requestQoute = document.querySelector('.product-form__rq');
                if (this.requestQoute) {
                    this.requestQoute.addEventListener('click', () => {
                        const addButton = document.querySelector('button[name="add"]');
                        console.log(addButton);
                        if (addButton) {
                            addButton.click();
                        }
                    });
                }
            }
            connectedCallback() {
                this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                    if (event.source === 'cart-items') {
                        
                        this.addonItems = this.querySelectorAll('addon-item');
                        this.propertyGroupID = document.querySelector('#product_group_id');
                        var cartData = event.cartData;
                        let cartItems = cartData.items;
                        let updates = {};
                        

                        if (cartItems.length > 0) {
                            for (let i = 0; i < cartItems.length; i++) {
                                let item = cartItems[i];
                                if (item.properties.addon_group_id) {
                                    if (event.groupID == item.properties.addon_group_id) {
                                        updates[item.key] = event.quantity;
                                    }
                                }
                            }

                            if (updates.length != 0) {
                                this.updateCart(updates);
                                updates = {};
                            } else {
                                console.log('No Add-ons to update');
                            }
                        }
                    }
                });
            }

            disconnectedCallback() {
                if (this.cartUpdateUnsubscriber) {
                    this.cartUpdateUnsubscriber();
                }
            }

            // Update the cart with new quantity values
            updateCart(updates) {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        updates: updates
                    })
                })
                .then(response => {
                    if (!response.ok) {
                        return response.text().then(errorText => {
                            throw new Error(errorText);
                        });
                    }
                    return response.json();
                })
                .then(data => {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'group-cart-items', cartData: data, variantId: this.variantID });
                    if ( data.item_count == 0 ) {
                        const cartdrawer = document.querySelector('cart-drawer');
                        const cartItem = cartdrawer.querySelectorAll('cart-drawer-items');
                        cartdrawer.classList.add('is-empty');

                        cartItem.forEach(item => {
                            item.classList.add('is-empty');
                        });
                        
                        this.refreshCart();
                    }
                    //console.log('Cart updated successfully', data);
                })
                .catch(error => {
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'group-cart-items', cartData: data, variantId: this.variantID });
                    console.error('Error updating cart:', error);
                    if ( data.item_count == 0 ) {
                        this.refreshCart();
                    }
                });
            }

            // Refresh the cart drawer
            refreshCart() {
                subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
                    if (event.source === 'product-form') return;
                });

                fetch('/')
                    .then(response => response.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');
                        const updatedCartItems = doc.querySelector('cart-drawer');
                        const currentCartItems = document.querySelector('cart-drawer');

                        if (updatedCartItems && currentCartItems) {
                            currentCartItems.innerHTML = updatedCartItems.innerHTML;
                        }

                        if (updatedCartItems.classList.contains('is-empty')) {
                            currentCartItems.classList.add('is-empty');
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching updated cart:', error);
                    });
            }

            // Debounce function to limit the rate of function calls
            debounce(func, wait) {
                let timeout;
                return function(...args) {
                    const context = this;
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(context, args), wait);
                };
            }
        }
    );
}



if (!customElements.get('quantity-selector')) {
customElements.define(
    'quantity-selector',
    class QuantitySelector extends HTMLElement {
    constructor() {
        super();
        this.quantityInput = null;
        this.formQTY = document.querySelector('#form__quantity');
    }

    connectedCallback() {
        this.quantityInput = this.querySelector('#quantity');
        this.decreaseButton = this.querySelector('#decrease');
        this.increaseButton = this.querySelector('#increase');

        this.decreaseButton.addEventListener('click', this.decreaseQuantity.bind(this));
        this.increaseButton.addEventListener('click', this.increaseQuantity.bind(this));

        // Update this.formQTY whenever this.quantityInput changes
        this.quantityInput.addEventListener('input', () => {
        this.formQTY.value = this.quantityInput.value;
        });
    }

    decreaseQuantity() {
        let quantity = parseInt(this.quantityInput.value) || 1;
        if (quantity > 1) {
        this.quantityInput.value = quantity - 1;
        this.formQTY.value = this.quantityInput.value; // Sync with formQTY
        }
    }

    increaseQuantity() {
        let quantity = parseInt(this.quantityInput.value) || 1;
        if (quantity < 99) {
        this.quantityInput.value = quantity + 1;
        this.formQTY.value = this.quantityInput.value; // Sync with formQTY
        }
    }
    }
);
}
  